module.exports = __webpack_public_path__ + "img/bankinter.a48dced0.png";